import * as React from 'react';
import { GroupHeaderBase } from './GroupedComboBoxGroupHeader.base';
import { styled } from '@fluentui/react';
import {
    IGroupedComboBoxGroupHeaderStyleProps,
    IGroupedComboBoxGroupHeaderStyles,
} from './GroupedComboBoxGroupHeader.types';
import { getStyles } from './GroupedComboBoxGroupHeader.styles';
import { IGroupedComboBoxGroupHeaderProps } from './GroupedComboBoxGroupHeader.types';

export const GroupHeader: React.FunctionComponent<IGroupedComboBoxGroupHeaderProps> = styled<
    IGroupedComboBoxGroupHeaderProps,
    IGroupedComboBoxGroupHeaderStyleProps,
    IGroupedComboBoxGroupHeaderStyles
>(GroupHeaderBase, getStyles);
